export interface SelectItem {
    text: string;
    id: any;
    data?: any;
    items?: SelectItem[];
}

